import { useDispatch, useSelector } from "react-redux";
import useLogOut from "../../hooks/useLogOut";
import NullCheck from "../../components/NullCheck";
import Details from "./tab/Details";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { apiUrl } from "config/settings";
import { setShowLoading, setShowMassage } from "store/sysSlice";
import useDataManager from "hooks/useDataManager";
import { setEmployees } from "store/employeesSlice";
import http from '../../http'
import { setSelectedLang, setUser } from "store/userSettingsSlice";
import Shortcuts from "./tab/Shortcuts";
import { useState } from "react";
import { SHORTCUT_NAVIGATE_TO } from "config/const";
import CustomDialog from "components/CustomDialog";

const Dialog = ({ open, setOpen }) => {
  const { editItem } = useDataManager()
  const dispatch = useDispatch()
  const { logOut } = useLogOut();
  const { reset, setValue, handleSubmit, control, formState: { errors } } = useForm();
  const userPaletteMode = useSelector((state) => state?.userSettings?.paletteMode);
  const empList = useSelector((state) => state?.employees?.list);
  const user = useSelector((state) => state.userSettings?.user);
  const [selectedTab, setSelectedTab] = useState(0)

  // const TABS = [
  //   { id: 0, title: 'DETAILS' },
  //   { id: 1, title: 'SHORTCUT' },
  // ]

  useEffect(() => {
    reset({
      ...user,
      lang: user?.lang?.id,
      userPaletteMode: userPaletteMode
    })
  }, [user, userPaletteMode]);

  const onClose = () => {
    setOpen(false);
  };

  const changeUserLocal = (data) => {
    dispatch(setUser({ ...user, ...data }))
    localStorage.setItem("user", JSON.stringify({ ...user, ...data }));
  }

  const onSubmit = (values) => {
    if (user?.hasTwoFactor && !values?.email)
      return dispatch(setShowMassage({ massage: "TWO_FACTOR_NEED_EMAIL_ERROR", type: "error" }));

    dispatch(setShowLoading(true));

    const shortcuts = values?.shortcuts
      ?.filter(item => item?.name && item?.icon && item?.path)
      ?.map((item, index) => {
        const newItem = SHORTCUT_NAVIGATE_TO?.find(i => i?.path === item?.path)
        return ({
          sysName: newItem?.pluginName,
          name: item?.name,
          path: item?.path,
          key: index + 1,
          icon: item?.icon
        })
      })

    let data = {
      fn: values.fn,
      ln: values.ln,
      tel: values.tel,
      email: values.email ?? "",
      shortcuts: shortcuts,
      hideFloatingNotifications: values.hideFloatingNotifications
    };

    try {
      http.patch(`${apiUrl}/employees/profile/${user?.id}`, data)
        .then((res) => {
          dispatch(setShowLoading(false));

          if (res?.data?.id === 1) {
            data.id = user?.id;
            const newList = editItem(data, empList);
            dispatch(setEmployees(newList))
            changeUserLocal(data)
            onClose();
          }
          else { dispatch(setShowMassage({ massage: "ERROR", type: "error" })) }
        })
    }
    catch (error) {
      dispatch(setShowMassage({ massage: "ERROR", type: "error" }));
      dispatch(setShowLoading(false));
    }

  };

  const handleClickLang = (lang) => {
    dispatch(setShowLoading(true));
    http.patch(`${apiUrl}/employees/changeLang/${user?.id}`, { lang }).then((res) => {
      dispatch(setSelectedLang(lang));
      changeUserLocal({ lang })
      dispatch(setShowMassage({ massage: "CHANGE_LANG_SUCCESS", type: "success" }));
      onClose()
      setTimeout(() => window.location.reload(), 1000);
    })
      .catch((error) => {
        dispatch(setShowLoading(false));
        dispatch(setShowMassage({ massage: "CHANGE_LANG_ERROR", type: "error" }));
      });
  };

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title="PRIVATE_AREA"
      actionBtn={{ title: "SAVE", onClick: () => handleSubmit(onSubmit)() }}
      closeBtn="CLOSE"
    // tabs={{
    //   list: TABS,
    //   scrollAmount: 20,
    //   callBackFunc: (e) => setSelectedTab(e),
    // }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <NullCheck valueForCheck={selectedTab === 0}>
          <Details
            control={control}
            errors={errors}
            data={user}
            userPaletteMode={userPaletteMode}
            handleClickLang={handleClickLang}
            logOut={logOut}
          />
        </NullCheck>

        <NullCheck valueForCheck={selectedTab === 1}>
          <Shortcuts
            control={control}
            errors={errors}
            data={user}
            setValue={setValue}
          />
        </NullCheck>
      </form>
    </CustomDialog>
  );
};
export default Dialog;
